import React, { useState } from 'react';
import { Tabs } from '../components/ui/Tabs';
import { Card, CardContent } from '../components/ui/Card';
import { CheckCircle, Target, Heart, Shield, Users, Zap, Download } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { SEO } from '../components/SEO';
export function ProfilPage() {
  const [activeTab, setActiveTab] = useState('tentang');
  const tabs = [{
    id: 'tentang',
    label: 'Tentang WKM'
  }, {
    id: 'sejarah',
    label: 'Sejarah'
  }, {
    id: 'visi-misi',
    label: 'Visi, Misi & Nilai'
  }, {
    id: 'komitmen',
    label: 'Komitmen'
  }, {
    id: 'legalitas',
    label: 'Legalitas'
  }];
  const handleDownloadCompanyProfile = () => {
    window.open('https://drive.google.com/file/d/1uTnFz_7YzLi1HhnoG9POlSh5stVvcW9A/view?usp=sharing', '_blank');
  };
  return <>
      <SEO title="Profil Perusahaan - PT Wahana Konstruksi Mandiri | Visi Misi & Legalitas" description="Profil lengkap PT Wahana Konstruksi Mandiri (WKM): Sejarah, Visi Misi GREAT, Komitmen Kualitas, Legalitas SBU, dan KBLI. Perusahaan konstruksi terpercaya sejak 2021." keywords="profil WKM, visi misi konstruksi, GREAT values, legalitas konstruksi, SBU konstruksi, KBLI, sejarah WKM, komitmen kualitas" data-id="element-459" />

      <div className="py-12 bg-wkm-slate-50 min-h-screen" data-id="element-460">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-461">
          <header className="text-center mb-12" data-id="element-462">
            <h1 className="text-4xl font-bold text-wkm-navy-900 mb-4" data-id="element-463">
              Profil Perusahaan
            </h1>
            <p className="text-lg text-wkm-slate-600 max-w-2xl mx-auto mb-6" data-id="element-464">
              Mengenal lebih dekat PT Wahana Konstruksi Mandiri sebagai mitra
              konstruksi terpercaya.
            </p>
            <Button onClick={handleDownloadCompanyProfile} size="lg" className="bg-wkm-gold-500 text-wkm-navy-900 hover:bg-wkm-gold-600" aria-label="Download Company Profile Lengkap" data-id="element-465">
              <Download className="w-4 h-4 mr-2" data-id="element-466" />
              Download Company Profile Lengkap
            </Button>
          </header>

          <div className="bg-white rounded-xl shadow-sm border border-wkm-slate-200 overflow-hidden" data-id="element-467">
            <div className="px-6 pt-2" data-id="element-468">
              <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} data-id="element-469" />
            </div>

            <article className="p-8 min-h-[400px]" data-id="element-470">
              {activeTab === 'tentang' && <div className="animate-in fade-in duration-300" data-id="element-471">
                  <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-472">
                    <div className="md:w-1/2" data-id="element-473">
                      <h2 className="text-2xl font-bold text-wkm-navy-900 mb-6" data-id="element-474">
                        Tentang Kami
                      </h2>
                      <p className="text-wkm-slate-600 mb-4 leading-relaxed" data-id="element-475">
                        PT Wahana Konstruksi Mandiri (WKM) adalah perusahaan
                        konstruksi yang bergerak di bidang konstruksi gedung
                        untuk industri, perkantoran, dan hunian, serta bangunan
                        sipil, jalan, dan jaringan irigasi & drainase.
                      </p>
                      <p className="text-wkm-slate-600 mb-6 leading-relaxed" data-id="element-476">
                        Berkantor pusat di Tanah Bumbu, Kalimantan Selatan, WKM
                        hadir untuk menjawab tantangan pembangunan infrastruktur
                        di Indonesia dengan mengedepankan kualitas, ketepatan
                        waktu, dan efisiensi biaya.
                      </p>
                      <div className="grid grid-cols-2 gap-4 mt-8" data-id="element-477">
                        <div className="p-4 bg-wkm-slate-50 rounded-lg border border-wkm-slate-100" data-id="element-478">
                          <h4 className="font-bold text-wkm-navy-900 mb-1" data-id="element-479">
                            Head Office
                          </h4>
                          <p className="text-sm text-wkm-slate-500" data-id="element-480">
                            Tanah Bumbu, Kalsel
                          </p>
                        </div>
                        <div className="p-4 bg-wkm-slate-50 rounded-lg border border-wkm-slate-100" data-id="element-481">
                          <h4 className="font-bold text-wkm-navy-900 mb-1" data-id="element-482">
                            Branch Office
                          </h4>
                          <p className="text-sm text-wkm-slate-500" data-id="element-483">
                            Samarinda, Kaltim
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="md:w-1/2" data-id="element-484">
                      <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Kantor PT Wahana Konstruksi Mandiri" className="rounded-lg shadow-lg w-full h-80 object-cover" data-id="element-485" />
                    </div>
                  </div>
                </div>}

              {activeTab === 'sejarah' && <div className="animate-in fade-in duration-300 max-w-3xl mx-auto" data-id="element-486">
                  <h2 className="text-2xl font-bold text-wkm-navy-900 mb-8 text-center" data-id="element-487">
                    Sejarah Singkat
                  </h2>
                  <div className="relative border-l-2 border-wkm-gold-200 ml-6 space-y-12" data-id="element-488">
                    <div className="relative pl-8" data-id="element-489">
                      <span className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-wkm-gold-500 border-4 border-white shadow-sm" data-id="element-490"></span>
                      <h3 className="text-xl font-bold text-wkm-navy-900 mb-2" data-id="element-491">
                        Desember 2021
                      </h3>
                      <p className="text-wkm-slate-600" data-id="element-492">
                        PT Wahana Konstruksi Mandiri resmi berdiri sebagai
                        respon terhadap peluang konstruksi & engineering yang
                        berkembang pesat di Indonesia, khususnya di Kalimantan
                        Selatan (Batulicin).
                      </p>
                    </div>
                    <div className="relative pl-8" data-id="element-493">
                      <span className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-wkm-slate-300 border-4 border-white" data-id="element-494"></span>
                      <h3 className="text-xl font-bold text-wkm-navy-900 mb-2" data-id="element-495">
                        Pertumbuhan
                      </h3>
                      <p className="text-wkm-slate-600" data-id="element-496">
                        Perusahaan terus berkembang dengan menekankan
                        pengalaman, kompetensi, dan SDM profesional untuk
                        memberikan layanan terbaik dan kepuasan klien.
                      </p>
                    </div>
                    <div className="relative pl-8" data-id="element-497">
                      <span className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-wkm-slate-300 border-4 border-white" data-id="element-498"></span>
                      <h3 className="text-xl font-bold text-wkm-navy-900 mb-2" data-id="element-499">
                        Masa Depan
                      </h3>
                      <p className="text-wkm-slate-600" data-id="element-500">
                        WKM kini bersiap untuk langkah strategis selanjutnya
                        melalui penguatan tata kelola dan ekspansi pasar yang
                        lebih luas.
                      </p>
                    </div>
                  </div>
                </div>}

              {activeTab === 'visi-misi' && <div className="animate-in fade-in duration-300" data-id="element-501">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-502">
                    <div data-id="element-503">
                      <h2 className="text-2xl font-bold text-wkm-navy-900 mb-6 flex items-center" data-id="element-504">
                        <Target className="w-6 h-6 mr-3 text-wkm-gold-600" data-id="element-505" />{' '}
                        Visi
                      </h2>
                      <ul className="space-y-4" data-id="element-506">
                        {['Meningkatkan kompetensi SDM berdasarkan core values GREAT', 'Menghadirkan produk & jasa berkualitas dengan teknologi terkini dan sistem terintegrasi', 'Memperkuat pengelolaan keuangan, manajemen risiko, dan tata kelola perusahaan', 'Memperluas jaringan bisnis swasta maupun pemerintahan'].map((item, i) => <li key={i} className="flex items-start" data-id="element-507">
                            <CheckCircle className="w-5 h-5 mr-3 text-wkm-gold-500 flex-shrink-0 mt-0.5" data-id="element-508" />
                            <span className="text-wkm-slate-700" data-id="element-509">{item}</span>
                          </li>)}
                      </ul>

                      <h2 className="text-2xl font-bold text-wkm-navy-900 mt-12 mb-6 flex items-center" data-id="element-510">
                        <Zap className="w-6 h-6 mr-3 text-yellow-500" data-id="element-511" /> Misi
                      </h2>
                      <p className="text-lg text-wkm-slate-700 font-medium border-l-4 border-yellow-400 pl-4 py-2 bg-yellow-50 rounded-r-lg" data-id="element-512">
                        Menjadi perusahaan terbaik yang berkontribusi untuk
                        kemajuan pembangunan di Indonesia.
                      </p>
                    </div>

                    <div data-id="element-513">
                      <h2 className="text-2xl font-bold text-wkm-navy-900 mb-6 flex items-center" data-id="element-514">
                        <Heart className="w-6 h-6 mr-3 text-red-500" data-id="element-515" /> Nilai
                        Perusahaan (GREAT)
                      </h2>
                      <div className="grid gap-4" data-id="element-516">
                        {[{
                      letter: 'G',
                      title: 'Grow & Improve Properly',
                      desc: 'Tumbuh dan berkembang dengan cara yang benar'
                    }, {
                      letter: 'R',
                      title: 'Respect & Care',
                      desc: 'Saling menghormati dan peduli'
                    }, {
                      letter: 'E',
                      title: 'Excellent Service',
                      desc: 'Pelayanan prima'
                    }, {
                      letter: 'A',
                      title: 'Absolute Integrity',
                      desc: 'Integritas mutlak'
                    }, {
                      letter: 'T',
                      title: 'Teamwork & Mutual Support',
                      desc: 'Kerjasama tim dan saling mendukung'
                    }].map((val, i) => <div key={i} className="flex items-center p-4 bg-wkm-slate-50 rounded-lg border border-wkm-slate-100" data-id="element-517">
                            <div className="w-12 h-12 bg-wkm-navy-700 text-white rounded-full flex items-center justify-center font-bold text-xl mr-4 flex-shrink-0" data-id="element-518">
                              {val.letter}
                            </div>
                            <div data-id="element-519">
                              <h4 className="font-bold text-wkm-navy-900" data-id="element-520">
                                {val.title}
                              </h4>
                              <p className="text-sm text-wkm-slate-500" data-id="element-521">
                                {val.desc}
                              </p>
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>}

              {activeTab === 'komitmen' && <div className="animate-in fade-in duration-300 max-w-4xl mx-auto" data-id="element-522">
                  <h2 className="text-2xl font-bold text-wkm-navy-900 mb-8 text-center" data-id="element-523">
                    Komitmen Perusahaan
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-524">
                    {['Profesionalitas dalam kerja sebagai jaminan integritas perusahaan', 'Jaminan mutu dalam setiap karya & kepuasan klien sebagai orientasi utama', 'Manajemen mutu serta pengendalian waktu & biaya secara efisien', 'Inovasi dengan kreativitas & teknologi sesuai tuntutan zaman', 'Membangun dengan orientasi ramah lingkungan untuk masa depan'].map((item, i) => <Card key={i} className="hover:border-wkm-gold-300 transition-colors" data-id="element-525">
                        <div className="flex items-start" data-id="element-526">
                          <Shield className="w-6 h-6 mr-4 text-wkm-gold-600 flex-shrink-0" data-id="element-527" />
                          <p className="text-wkm-slate-700 font-medium" data-id="element-528">
                            {item}
                          </p>
                        </div>
                      </Card>)}
                  </div>
                </div>}

              {activeTab === 'legalitas' && <div className="animate-in fade-in duration-300" data-id="element-529">
                  <h2 className="text-2xl font-bold text-wkm-navy-900 mb-8" data-id="element-530">
                    Legalitas & Sertifikasi
                  </h2>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-531">
                    <div className="bg-wkm-slate-50 p-6 rounded-xl border border-wkm-slate-200" data-id="element-532">
                      <h3 className="text-lg font-bold text-wkm-navy-900 mb-4 border-b border-wkm-slate-200 pb-2" data-id="element-533">
                        SBU Konstruksi
                      </h3>
                      <dl className="space-y-3 text-sm" data-id="element-534">
                        <div className="flex justify-between" data-id="element-535">
                          <dt className="text-wkm-slate-500" data-id="element-536">PB-UMKU</dt>
                          <dd className="font-mono font-medium text-wkm-navy-900" data-id="element-537">
                            11012200087060010003
                          </dd>
                        </div>
                        <div className="flex justify-between" data-id="element-538">
                          <dt className="text-wkm-slate-500" data-id="element-539">
                            Pelaksana Sertifikasi
                          </dt>
                          <dd className="font-medium text-wkm-navy-900" data-id="element-540">
                            PT. Serbu Konstruksi Mandiri
                          </dd>
                        </div>
                        <div className="flex justify-between" data-id="element-541">
                          <dt className="text-wkm-slate-500" data-id="element-542">Kualifikasi</dt>
                          <dd className="font-medium text-wkm-navy-900" data-id="element-543">
                            Menengah
                          </dd>
                        </div>
                        <div className="flex justify-between" data-id="element-544">
                          <dt className="text-wkm-slate-500" data-id="element-545">Kode Subklas</dt>
                          <dd className="font-mono font-medium text-wkm-navy-900" data-id="element-546">
                            BG001
                          </dd>
                        </div>
                        <div className="flex justify-between" data-id="element-547">
                          <dt className="text-wkm-slate-500" data-id="element-548">PJSKBU</dt>
                          <dd className="font-medium text-wkm-navy-900" data-id="element-549">
                            Gest(i) Pramudya
                          </dd>
                        </div>
                      </dl>
                    </div>

                    <div className="bg-wkm-slate-50 p-6 rounded-xl border border-wkm-slate-200" data-id="element-550">
                      <h3 className="text-lg font-bold text-wkm-navy-900 mb-4 border-b border-wkm-slate-200 pb-2" data-id="element-551">
                        KBLI
                      </h3>
                      <p className="text-wkm-slate-600 mb-4 text-sm" data-id="element-552">
                        Kelompok konstruksi gedung (hunian, perkantoran,
                        industri, perbelanjaan, kesehatan, pendidikan,
                        penginapan, hiburan/olahraga, lainnya).
                      </p>
                      <div className="flex flex-wrap gap-2" data-id="element-553">
                        {['41011', '41012', '41013', '41014', '41015', '41016', '41017', '41018', '41019'].map(code => <span key={code} className="px-3 py-1 bg-white border border-wkm-slate-200 rounded text-sm font-mono text-wkm-slate-700" data-id="element-554">
                            {code}
                          </span>)}
                      </div>
                    </div>
                  </div>
                </div>}
            </article>
          </div>
        </div>
      </div>
    </>;
}